import { User } from "@modules/users/users.interface";
import { SituazioneRuoli } from "@modules/roles/roles.interface";
import { dashboardStoreKey } from './store.selector';

export interface IStoreState {
  situazioneRuoli?: Partial<SituazioneRuoli>,
  users: Partial<User[]>,
  user: Partial<User>,
  token: string;
  userIrenYou: string;
}

export const EmptyStoreState: IStoreState = {
  situazioneRuoli: null,
  users: null,
  user: null,
  token: null,
  userIrenYou: null
};

const getStoreFromStorage = (): IStoreState => {
  const state = localStorage.getItem(dashboardStoreKey);
  return state ? JSON.parse(state) : EmptyStoreState;
};

export const InitialStoreState: IStoreState = getStoreFromStorage();
